import { MathUtils, Vector2, Vector3 } from 'three';

export default class LatLong {
  static toVector3(lat, long, radius, target) {
    target = target || new Vector3();
    const theta = -MathUtils.DEG2RAD * long;
    const phi = MathUtils.DEG2RAD * lat;
    const cosPhi = Math.cos(phi);

    target.x = Math.cos(theta) * cosPhi * radius;
    target.y = Math.sin(phi) * radius;
    target.z = Math.sin(theta) * cosPhi * radius;

    return target;
  }

  static fromVector3(point, target) {
    target = target || new Vector2();
    const r = point.length();

    const theta = Math.atan2(point.z, point.x);
    const phi = Math.asin(point.y / r);

    target.x = -MathUtils.RAD2DEG * theta; // long
    target.y = MathUtils.RAD2DEG * phi; // lat
    return target;
  }
}
